<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Share with us some information about your BIR-filed FS</h3>
                    </div>
                    <div class="card-body">
                        <p class="card-text text-justify">Do you have a BIR-filed Financial Statements?</p>
                        <div class="row">
                            <div class="col-6 text-center">
                                <div class="icheck-primary d-inline">
                                    <input type="radio" id="y" value="Y" v-model="formLoan.bir">
                                    <label for="y" :class="{ 'errorRadio': $parent.submitting && $v.formLoan.bir.$error }">Yes</label>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="icheck-primary d-inline">
                                    <input type="radio" id="n" value="N" v-model="formLoan.bir" @change="formLoan.tin=''">
                                    <label for="n" :class="{ 'errorRadio': $parent.submitting && $v.formLoan.bir.$error }">No</label>
                                </div>
                            </div>
                        </div>

                        <!-- <div v-if="formLoan.loan_bus_code=='FIB05'">
                            <div v-if="formLoan.bir=='Y'">
                                <hr>
                                <div class="alert alert-info2">
                                    <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>
                                    This will require you to upload the required documents. Kindly merge the documents as one PDF file and upload it later in step 4. Kindly upload a clear and complete copy of your BIR-filed financial statement 2019 or 2020. Specifically, your submission should include the following: a) BIR Form 1701 (Sole Proprietorship) / BIR Form 1702 (Corporation/Partnership; b) Balance Sheet;
                                    and, c) Income Statement.
                                </div>
                                <div class="mt-2">
                                    <div class="form-group">
                                        <a href="templatedFILE/Sample BIR Form 1701.pdf" download>Download Sample BIR Form 1701</a>
                                        <br>
                                        <a href="templatedFILE/Sample BIR Form 1702.pdf" download>Download Sample BIR Form 1702</a>
                                    </div>
                                </div>
                                <div class="alert alert-warning2">
                                    <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>use higher figure from any of the submitted BIR-filed FS.
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Asset Size</label>
                                            <div class="input-group input-group-sm">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                                                </div>
                                                <input v-if="asset_size" @blur="asset_size=false" @paste.prevent @keypress="maxNum($event)" type="number" class="form-control" v-model="formLoan.asset_size" :class="{'is-invalid': $parent.submitting && $v.formLoan.asset_size.$error}">
                                                <input v-else @focus="asset_size=true" type="text" class="form-control" :value="formLoan.asset_size ? $options.filters.curr(formLoan.asset_size) : null" :class="{'is-invalid': $parent.submitting && $v.formLoan.asset_size.$error}">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Annual Sales</label>
                                            <div class="input-group input-group-sm">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                                                </div>
                                                <input v-if="annual_sale" @blur="annual_sale=false" @paste.prevent @keypress="maxNum($event)" type="number" class="form-control" v-model="formLoan.annual_sale" :class="{'is-invalid': $parent.submitting && $v.formLoan.annual_sale.$error}">
                                                <input v-else @focus="annual_sale=true" type="text" class="form-control" :value="formLoan.annual_sale ? $options.filters.curr(formLoan.annual_sale) : null" :class="{'is-invalid': $parent.submitting && $v.formLoan.annual_sale.$error}">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Input your Tax Identification Number (TIN) here</label>
                                            <input type="text" class="form-control form-control-sm" v-model="formLoan.tin" :class="{'is-invalid': $parent.submitting && $v.formLoan.tin.$error}" v-input-mask data-inputmask-mask="999-999-999-999" data-inputmask-placeholder="">
                                            <span class="fs-13 danger" v-if="$parent.submitting && $v.formLoan.tin.$error">Not a valid TIN format</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div>
                            <div v-if="formLoan.bir">
                                <hr>
                                <div v-if="formLoan.bir=='Y'">
                                    <div class="alert alert-info2">
                                        <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>This will require you to upload the required documents. Kindly merge the documents as one PDF file and upload it later in step 4. Kindly upload a clear and complete copy of your BIR-filed financial statement 2018 or 2019 or 2020. Specifically, your submission should include the following: a) BIR Form 1701 (Sole Proprietorship) / BIR Form 1702 (Corporation/Partnership; b) Balance Sheet;
                                        and, c) Income Statement.
                                    </div>
                                    <div class="mt-2">
                                        <div class="form-group">
                                            <a href="templatedFILE/Sample BIR Form 1701.pdf" download>Download Sample BIR Form 1701</a>
                                            <br>
                                            <a href="templatedFILE/Sample BIR Form 1702.pdf" download>Download Sample BIR Form 1702</a>
                                        </div>
                                    </div>
                                    <div class="alert alert-warning2">
                                        <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>use higher figure from any of the submitted BIR-filed FS.
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                        <label>Estimated Asset Size (excluding land)</label>
                                            <div class="input-group input-group-sm">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                                                </div>
                                                <input v-if="asset_size" @blur="asset_size=false" @paste.prevent @keypress="maxNum($event)" type="number" class="form-control" v-model="formLoan.asset_size" :class="{'is-invalid': $parent.submitting && $v.formLoan.asset_size.$error}">
                                                <input v-else @focus="asset_size=true" type="text" class="form-control" :value="formLoan.asset_size ? $options.filters.curr(formLoan.asset_size) : null" :class="{'is-invalid': $parent.submitting && $v.formLoan.asset_size.$error}">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                        <label>Estimated Annual Sales</label>
                                            <div class="input-group input-group-sm">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                                                </div>
                                                <input v-if="annual_sale" @blur="annual_sale=false" @paste.prevent @keypress="maxNum($event)" type="number" class="form-control" v-model="formLoan.annual_sale" :class="{'is-invalid': $parent.submitting && $v.formLoan.annual_sale.$error}">
                                                <input v-else @focus="annual_sale=true" type="text" class="form-control" :value="formLoan.annual_sale ? $options.filters.curr(formLoan.annual_sale) : null" :class="{'is-invalid': $parent.submitting && $v.formLoan.annual_sale.$error}">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group" v-if="formLoan.bir=='Y'">
                                    <label>Input your Tax Identification Number (TIN) here</label>
                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.tin" :class="{'is-invalid': $parent.submitting && $v.formLoan.tin.$error}" v-input-mask data-inputmask-mask="999-999-999-999" data-inputmask-placeholder="">
                                    <span class="fs-13 danger" v-if="$parent.submitting && $v.formLoan.tin.$error">Not a valid TIN format</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                        <button class="btn btn-primary float-right" @click="next">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>

                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import moment from 'moment';
    import {
        required,
        minLength,
        requiredIf
    } from 'vuelidate/lib/validators';

    export default {
        props: ['formLoan'],
        data() {
            return {
                asset_size: false,
                annual_sale: false,
            }
        },

        validations: {
            formLoan: {
                bir: {
                    required
                },
                asset_size: {
                    required: requiredIf(function() {
                        return this.req_if();
                    })
                },
                annual_sale: {
                    required: requiredIf(function() {
                        return this.req_if();
                    })
                },
                tin: {
                    required: requiredIf(function() {
                        return this.formLoan.bir == 'Y';
                    }),
                    minLength: minLength(15),
                },
            },
        },
        created() {},
        methods: {
            req_if() {
                if (this.formLoan.bir == 'Y') {
                    return true;
                } else {
                    return true;
                }
            },
            next() {
                this.$parent.submitting = false;
                this.$parent.submitting = true;

                this.$v.formLoan.$touch();

                if (this.$v.formLoan.$invalid) {} else {
                    this.$emit('next');
                }
            },

            maxNum(e) {
                let val = e.target.value;
                let dot = val.indexOf('.') !== -1
                let dec = val.substr(val.indexOf('.'));
                if (val <= 99999999) {
                    if (dot) {
                        if (dec.length >= 3) {
                            e.preventDefault();
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                } else e.preventDefault();
            },
        },
        computed: {

        },
        mounted() {}
    }
</script>



<style scoped>
    label {
        font-weight: 400 !important;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>